<template>
  <div class="pt-panel trunk-info-panel">
    <div class="pt-header">
      <div class="pt-header-text">
        <div class="pt-kicker">工程信息</div>
        <h2 class="pt-title">{{ oneTitle }}</h2>
        <p class="pt-subtitle">干线工程参数 · 管线布置</p>
      </div>
      <button class="pt-close" @click="closeClick">&times;</button>
    </div>

    <div class="pt-flex-table">
      <div class="pt-flex-table-header">
        <div class="pt-flex-table-cell">名称</div>
        <div class="pt-flex-table-cell">形式</div>
        <div class="pt-flex-table-cell">长度</div>
      </div>
      <div
          class="pt-flex-table-row"
          v-for="(item, index) in lineData"
          :key="index"
      >
        <div class="pt-flex-table-cell">{{ item.name }}</div>
        <div class="pt-flex-table-cell">{{ item.type }}</div>
        <div class="pt-flex-table-cell">{{ item.length }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hightTrunkInfo",
  data() {
    return {
      oneTitle: "干线详情",
      lineData: [
        { name: "渭塬高干线", type: "压力管道", length: "55.65 km" },
        { name: "渭塬中干线", type: "暗涵 / 隧洞 / 压力管道", length: "127.39 km" },
        { name: "渭塬低干线", type: "渠道（利用已成渠道）", length: "97.10 km" },
      ],
    };
  },
  methods: {
    closeClick() {
      this.$emit("infoClose");
    },
  },
};
</script>

<style scoped>
.trunk-info-panel {
  width: 45%;
  height: 65%;
  position: absolute;
  overflow-y: auto;
  max-height: 65%;
  left: 30%;
  top: 200px;
}
</style>
